import { StaticImageData } from 'next/image'

import {
  BrisbaneGolfClubImage,
  BrisbaneGolfClubLogoImage,
  KingstonHeathVicImage,
  KingstonHeathVicLogoImage,
  NewSouthWalesNSWImage,
  NewSouthWalesNSWLogoImage,
  TheLakesNSWImage,
  TheLakesNSWLogoImage,
} from 'Assets/Images/Sections/AccessSection'

export enum AccessSectionGalleryItemId {
  Brisbane = 'Brisbane',
  Kingston = 'Kingston',
  NewSouthWales = 'NewSouthWales',
  TheLakes = 'TheLakes',
}

type AccessSectionGalleryItem = {
  id: AccessSectionGalleryItemId
  image: StaticImageData
  logo: StaticImageData
  caption: string
}

export const ACCESS_SECTION_GALLERY_ITEMS: AccessSectionGalleryItem[] = [
  {
    id: AccessSectionGalleryItemId.Brisbane,
    image: BrisbaneGolfClubImage,
    logo: BrisbaneGolfClubLogoImage,
    caption: 'Brisbane Golf Club - QLD',
  },
  {
    id: AccessSectionGalleryItemId.Kingston,
    image: KingstonHeathVicImage,
    logo: KingstonHeathVicLogoImage,
    caption: 'Kingston Heath - VIC',
  },
  {
    id: AccessSectionGalleryItemId.NewSouthWales,
    image: NewSouthWalesNSWImage,
    logo: NewSouthWalesNSWLogoImage,
    caption: 'New South Wales - NSW',
  },
  {
    id: AccessSectionGalleryItemId.TheLakes,
    image: TheLakesNSWImage,
    logo: TheLakesNSWLogoImage,
    caption: 'The Lakes - NSW',
  },
]
